import hostConfig from '@/config/odas/properties/host_config.yml';
import hostSolutions from '@/config/odas/properties/host_solutions.yml';

const getBaseProps = (context) => ({
  host: findSolutionKey(context.req.headers.host),
  isLoggedIn: !!context.req.cookies['one-degree_jwt_token']
});

// callback function is optional for further processing by the caller
export const buildServerSideProps = (callback = (_, args) => args) => {
  return (context) => {
    return callback(context, { props: getBaseProps(context) });
  };
};

// TODO this logic is replicated from pages that were looking for data on req.query,
// but that doesn't appear to be filled in with url params, so will need a refactor.
export const buildServerSidePropsWithReqParams = (params) => {
  return (context) => {
    const args = { props: getBaseProps(context) };
    // for the key,val pairs in params, pull from the request object,
    // and use the provided value as a default
    Object.entries(params).forEach(([key, defaultVal]) => {
      // TODO as above comment says, these params don't live on the req object
      args.props[key] = typeof context.req[key] === 'undefined' ? defaultVal : context.req[key];
    });
    return args;
  };
};

let SOLUTION_MAP = null;

// TODO can this be calculated once on startup?
function getSolutionMap() {
  if (SOLUTION_MAP) return SOLUTION_MAP;

  SOLUTION_MAP = {}; // host => solution key
  hostSolutions[process.env.NEXT_PUBLIC_HOST_SOLUTIONS_ENV].solutions.forEach((data) => {
    data.hosts.forEach((host) => {
      SOLUTION_MAP[host] = data.solution;
    });
  });
  return SOLUTION_MAP;
}

export function getSolution(hostKey) {
  return hostConfig.hosts[hostKey];
}

export function solutionFromHost(host, verbose = true) {
  const key = findSolutionKey(host, verbose);
  if (null) return null; // happens on docker status check
  return getSolution(key);
}

export function findSolutionKey(host, verbose = true) {
  const solutionMap = getSolutionMap();
  if (solutionMap[host]) {
    return solutionMap[host];
  }
  // throw new Error('Could not findSolutionKey for', host);
  // ignoring this once-every-few-seconds case of requests for `/status` on localhost:3001 in staging
  if (verbose) {
    console.warn('Could not findSolutionKey for', host, 'on', process.env.NEXT_PUBLIC_HOST_SOLUTIONS_ENV);
  }
  return null; // TODO switch to throwing an error
}
